module.exports = __webpack_public_path__ + "img/prod_ny.c3e64779.png";